<template>
  <div v-if="isThereAnyContract">
    <div class="mt-3 text-center sm:mt-5">
      <DialogTitle as="h3" class="text-lg text-center leading-6 font-medium text-gray-900">
        {{ $t("Available Contracts") }}
      </DialogTitle>

      <Table class="mt-8 text-left" :data="variant.matchedContracts" :columns="contractColumns">
        <template #price="{ row }">
          {{ formatPrice(row.price) }}
        </template>
      </Table>
    </div>
  </div>
  <div v-else class="text-center mt-5">
    <p>{{ $t("No contract available for this variant") }}</p>
  </div>
</template>
<script>
import { Table, formatPrice } from "@estaly/ui";

export default {
  components: {
    Table,
  },

  props: ["variant"],

  computed: {
    isThereAnyContract: function () {
      return this.variant.matchedContracts.length !== 0;
    },

    contractColumns() {
      return [
        {
          field: "title",
          label: this.$t("Title"),
        },
        {
          field: "price",
          label: this.$t("Pricing"),
          slot: "price",
        },
      ];
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
